<div class="d-flex justify-content-between m-3" style="height: 50px;">
	<!-- <div class="h2 m-10">
	</div> -->
			<ng-container *ngIf="this.transactionService.itemToEdit.AssignedToCurrentUser">
				<button class="d-n mt-2"  mat-raised-button
						(click)="tryUpdateFormData('update-pdf-form')">
					<span *ngIf="!isSaving()">{{ 'save' | translate }}</span>

					<div 	*ngIf="isSaving() && saving.action=='update-pdf-form'"
							class="d-flex justify-content-center align-items-center">
						<mat-spinner  [diameter]="20"
									class="mat-spinner-color">
						</mat-spinner>
					</div>
				</button>
			</ng-container>


			<!-- <button class="d-n mt-2" mat-raised-button
					(click)="validateFormManually()">
					Validate Form (Debug)
			</button>
			 -->
			<button class="d-n mt-2" mat-raised-button
					(click)="downloadPdfWithFormData()">
				{{ 'documentViewer.download' | translate }}
			</button>

			<button color="primary" class="d-n mt-2" style="height: 40.01px;"
					mat-raised-button (click)="close()">
					{{ 'close' | translate }}
			</button>
</div>

<div *ngIf="mainService.fileToLoad && !formDataReady" class="d-flex justify-content-center align-items-center p-5">
	<mat-spinner [diameter]="40"></mat-spinner>
	<span class="ml-3">{{ 'loading' | translate }}</span>
</div>

<!--
  PdfForm (técnico): sin [formData] — ngx 9 no pinta bien checkboxes; hidratar tras pagesLoaded.
  Otros PDF editables: con [formData].
-->
<ng-container *ngIf="mainService.fileToLoad && isPDF == false && formDataReady && ngxMountReady">
	<ngx-extended-pdf-viewer *ngIf="isPdfForm"
							[src]="mainService.fileToLoad"
							height="100%"
							width="100%"
							[showDownloadButton]="false"
							[showPrintButton]="false"
							[delayFirstView]="150"
							(pagesLoaded)="onAcroFormPagesLoaded()"
							(formDataChange)="onFormChange($event)">
	</ngx-extended-pdf-viewer>
	<ngx-extended-pdf-viewer *ngIf="!isPdfForm"
							[src]="mainService.fileToLoad"
							height="100%"
							width="100%"
							[formData]="mainService.formData"
							[showDownloadButton]="false"
							[showPrintButton]="false"
							[delayFirstView]="150"
							(formDataChange)="onFormChange($event)">
	</ngx-extended-pdf-viewer>
</ng-container>
<ng-container *ngIf="mainService.fileToLoad && isPDF == true && formDataReady">
	<iframe frameborder="0" height="100%" width="100%" [src]="mainService.fileToLoad | safe">
	</iframe>
</ng-container>
